import type React from 'react';

// Asset imports - bundler handles path resolution
import sphereVideo from '~/static/assets/videos/sphere.mp4';

interface FooterBackgroundProps {
  className?: string;
}

export const FooterBackground: React.FC<FooterBackgroundProps> = ({ className }) => {
  return (
    <video
      className={`footer-background-video ${className || ''}`}
      autoPlay
      loop
      muted
      playsInline
      tabIndex={-1}
    >
      <source src={sphereVideo} type="video/mp4" />
    </video>
  );
};

export default FooterBackground;
